"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var rocket_1 = require("../../core/rocket");
var orbit_1 = __importDefault(require("../orbit"));
var adressa_1 = __importDefault(require("./adressa"));
var ap_1 = __importDefault(require("./ap"));
var bt_1 = __importDefault(require("./bt"));
var e24_1 = __importDefault(require("./e24"));
var facebook_1 = __importDefault(require("./facebook"));
var vg_1 = __importDefault(require("./vg"));
var Compilation = function (_a) {
    var _b = _a.animate, animate = _b === void 0 ? true : _b, svgProps = __rest(_a, ["animate"]);
    var _c = react_1.useState(120), revolution = _c[0], setRevolution = _c[1];
    react_1.useEffect(function () {
        var timer = setTimeout(function () {
            setRevolution(30);
        }, 120 * 1000);
        return function () { return clearTimeout(timer); };
    }, []);
    return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 100 100", version: "1.1" }, svgProps),
        react_1.default.createElement("g", { transform: "translate(43, 57)" },
            react_1.default.createElement("g", { transform: "translate(-23, -23)" },
                react_1.default.createElement(rocket_1.Rocket, { width: 46, height: 46 })),
            react_1.default.createElement(orbit_1.default, { x: 42.95, y: -29.98, rx: 43.3, ry: 28, start: 0.33, width: 23.8, height: 23.8, parentWidth: 46, parentHeight: 46, revolution: revolution, animate: animate },
                react_1.default.createElement(vg_1.default, null)),
            react_1.default.createElement(orbit_1.default, { x: -8.5, y: -31.5, rx: 40, ry: 29, start: 4.934, width: 23, height: 23, parentWidth: 46, parentHeight: 46, revolution: revolution, animate: animate },
                react_1.default.createElement(facebook_1.default, null)),
            react_1.default.createElement(orbit_1.default, { x: 16, y: -43, rx: 44, ry: 26.2, start: 5.47, width: 12, height: 12, parentWidth: 46, parentHeight: 46, revolution: revolution, animate: animate },
                react_1.default.createElement(adressa_1.default, null)),
            react_1.default.createElement(orbit_1.default, { x: 19.5, y: 19.5, rx: 44, ry: 28.6, start: 1.834, width: 15, height: 15, parentWidth: 46, parentHeight: 46, revolution: revolution, animate: animate },
                react_1.default.createElement(e24_1.default, null)),
            react_1.default.createElement(orbit_1.default, { x: 41, y: 9, rx: 39, ry: 39, start: 1.14, width: 16, height: 16, parentWidth: 46, parentHeight: 46, revolution: revolution, animate: animate },
                react_1.default.createElement(ap_1.default, null)),
            react_1.default.createElement(orbit_1.default, { x: 33.5, y: -7.5, rx: 36, ry: 26, start: 0.783, width: 11, height: 11, parentWidth: 46, parentHeight: 46, revolution: revolution, animate: animate },
                react_1.default.createElement(bt_1.default, null)))));
};
exports.default = Compilation;
